export const SQUARE_SIZE = 50 // px
export const MIN_SQUARE_SIZE = 30 // px
export const DIRECTIONS = [
  "horizontal",
  "vertical",
  "diagonal",
  "reverse_horizontal",
  "reverse_vertical",
  "reverse_diagonal",
]
export const MIN_WORD_LENGTH = 2
export const MAX_WORD_LENGTH = 16
